import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SuraUiModule } from '@view/shared/sura-ui.module';
import { GenericModalComponent } from '../generic-modal';
import { BellNotificationComponent } from './bell-notification/bell-notification.component';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, SuraUiModule, RouterModule, GenericModalComponent, BellNotificationComponent],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  private readonly elementRef = inject(ElementRef);

  @Input() user!: { fullName: string; lastAccess: Date };
  @Input() userMenuActive = false;
  @Input() showAvatarSection = true;
  @Input() isExpanded = false;
  @Output() userMenuActiveChange = new EventEmitter<boolean>();
  @Output() logout = new EventEmitter<void>();

  showInfoModal = false;
  readonly modalImage = 'Bienestar_digital_810x1080.png';
  readonly modalTitle = '¿Quieres visitar el sitio de Biociencias?';
  readonly modalBold = '';
  readonly modalDesc =
    'Abriremos una nueva pestaña para que navegues el sitio y encuentres información detallada sobre nuestros productos.';
  readonly noText = 'Quedarme aquí';
  readonly yesText = 'Ir a Biociencias';

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    const target = event.target as HTMLElement;
    const clickedInside = this.elementRef.nativeElement.contains(target);

    if (!clickedInside && this.userMenuActive) {
      this.userMenuActiveChange.emit(false);
    }
  }

  toggleUserMenu(): void {
    this.userMenuActiveChange.emit(!this.userMenuActive);
  }

  onLogout(): void {
    this.logout.emit();
  }

  openInfoModal(): void {
    this.showInfoModal = true;
  }

  closeInfoModal(): void {
    this.showInfoModal = false;
  }

  onModalConfirm(): void {
    window.open(
      'https://www.sura.co/biociencias/empresas/ciencia-de-datos',
      '_blank',
      'noopener'
    );
    this.closeInfoModal();
  }
}
